import * as React from 'react';
import * as PropTypes from 'prop-types';
import Loading from 'components/Loading';
import styles from 'components/ReactTableComponent/components/LoadingComponent/LoadingComponent.module.scss';

export function ChecksLoadingComponent(props) {
  ChecksLoadingComponent.propTypes = {
    loading: PropTypes.bool,
  };
  if (props.loading) {
    return (
      <div className={styles.grayBackground}>
        <Loading />
      </div>
    );
  }
  return <></>;
}
